import { getImageURL, getHostURL } from '../utils/GeneralUtil'; // relocate to remove ProgramDetailsTiers dependency
//* ************ General ************ *//
// List of all general text, links, and assets for RewardsHub
export var rhGeneral = {
    perksPage: getHostURL('myaccount/proXtraPerks'),
    faqTermsAndConditions: getHostURL('c/pro-xtra-terms-and-conditions'),
    faqAnchor: 'pro_xtra_FAQ',
    assets: {
        ProXtraPerks: getImageURL("ProTiers/cardIcon-ProXtraPerks-square.svg"),
        pxcc: getImageURL('ProTiers/PXCC-padded-square.svg'),
        badge_unlocked: getImageURL('ProTiers/icon-badge-unlocked-square.svg'),
        PersonalOffers: getImageURL("ProTiers/cardIcon-PersonalOffers-square.svg"),
    },
    genericError: 'Something went wrong. Please refresh to try again.',
    elitePhoneNumber: '(888)948-3375',
};
//* ************ Component-specific ************ *//
export var rhFAQ = {
    headingTitle: ['Questions About', 'Pro Xtra Rewards?'],
};
export var rhBanner = {
    deadlineText: "Enjoy these rewards and benefits through",
};
export var rhTiers = {
    headingTitle: ['Unlock additional', 'Pro Xtra Benefits'],
    headingSubtitle: "Each Pro Xtra tier unlocks more great savings and value.",
    tierSpendAmounts: {
        MEMBER: "$0 - $25k",
        ELITE: "$25k+",
        VIP: "$250k+",
    },
};
export var rhTierRewards = {
    textNoData: function (objName) {
        return "Currently, you have no ".concat(objName, ". Check back again soon.");
    },
    rewardsError: function (objName) {
        return "Something went wrong. Please refresh to view ".concat(objName, ".");
    },
    expiresToday: "Expires Today",
    rewards: {
        headingTitle: "Rewards Available",
        ctaShowAll: "View All Rewards",
    },
    offerRewards: {
        headingTitle: "Offers Available",
        ctaShowAll: "Show All Offers",
    },
    perkRewards: {
        headingTitle: "Perks Available",
        ctaShowAll: "Show All Perks",
        ctaTrackProgress: "Track Progress",
        ctaViewPerkOptions: "View Options",
        ctaViewPerkHistory: "View History",
        ctaViewCardDetails: "View Details",
        unlockPerks: "Unlock Perks As You Spend",
        multiplierPxcc: function (multiplier) {
            return "You\u2019re Earning ".concat(multiplier || 1, "X Faster");
        },
        remainingSpend: function (amount) { return [
            "Spend".concat(amount ? " ".concat(amount, " ") : ' ', "more to unlock your next Perk"),
        ]; },
        remainingSpendPxcc: " Until Your Next Perk with the Pro Xtra Credit Card",
        wellDone: "Well Done",
        newUnlocked: "New Perk Unlocked",
    },
};
export var rhDrawer = {
    redeemInStoreConstant: 'To redeem in-store, access your Bonus Perk from the Account section of your profile through the Home Depot app or at homedepot.com on a mobile browser.',
    RewardsListInfo: 'Redeem your Perks and offers at check-out in-store or online. When shopping online, find your Perks listed along with other forms of payment.',
    OffersListInfoMobile: 'Enjoy exclusive, members-only offers on products and services.',
    OffersListInfoDesktop: 'Enjoy exclusive, members-only offers on products and services.',
    PerkErrorMessage: 'An error has occurred. These rewards cannot be displayed at this time. Please close the drawer and open it again.',
    challengeErrorMessage: 'Something went wrong. Please refresh to try again.',
    PerksListInfo: 'Redeem your Perks at check-out in-store or online. When shopping online, ' +
        'find your Perks listed along with other forms of payment.',
    noPerks: 'Perks no longer available.',
    noOffers: 'Offers no longer available.',
    noChallenge: 'Challenge is no longer available',
};
export var redeemInStoreConstant = 'To redeem in-store, access your offer from the Account section of your profile through The Home Depot app or at homedepot.com on a mobile browser.';
export var benefitTags = {
    eliteSupportLine: 'eliteCallCenter',
    proAccountBlueprint: 'ProAccountBlueprint',
};
export var rhAnalytics = {
    viewCardDetails: 'rewards hub: perks card: view card details button',
    showAllOffers: 'rewards hub: offers card: show all offers button',
    showAllPerks: 'rewards hub: perks card: show all perks button',
    trackProgressButton: 'rewards hub: perks card: track progress button',
    quotes: 'rewards hub: business tools: quotes link',
    volumePricing: 'rewards hub: business tools: volume pricing link',
    text2Confirm: 'rewards hub: business tools: text2confirm link',
    purchaseTracking: 'rewards hub: business tools: purchase tracking link',
    path2Pro: 'rewards hub: business tools: path to pro network link',
    proReferral: 'rewards hub: business tools: pro referral link',
    eliteSupportLine: 'rewards hub: elite support line: phone number link',
    paintInfoTooltip: 'rewards hub: paint info tooltip',
    viewPaintHistoryStash: 'rewards hub: paint rewards: view history',
    viewPaintHistoryOverlay: 'rewards hub: paint rewards history',
    preferredPricing: 'rewards hub: preferred pricing: learn more',
    viewRewardsHistory: 'rewards hub: view your rewards history',
    viewPerkOptions: 'rewards hub: view perk options',
    viewPerkHistory: 'rewards hub: view perk history',
    perkDetailsDrawer: 'rewards hub: perk details drawer',
    perkAvailableDrawer: 'rewards hub: perk available drawer',
    offerDetailsDrawer: 'rewards hub: offer details drawer',
    offersAvailableDrawer: 'rewards hub: offers available drawer',
    challengeOptedIn: 'rewards hub: offer details drawer: challenge: opt in',
    challengeEnrolled: 'rewards hub: offer details drawer: challenge: enrolled',
    returnToTop: 'rewards hub: faq: return to top button',
    termsAndConditions: 'rewards hub: pro xtra terms and conditions link',
};
